module.exports = __webpack_public_path__ + "img/img_activate.4aa2741c.png";